// node_modules
import { createContext, useContext } from "react";
// Controllers
import { WebsocketController, WebsocketControllerSingleton} from "Controllers";

type TWebsocketContext = {
    webSocketController: WebsocketController
}

export const WebsocketContext = createContext<TWebsocketContext>({
    webSocketController: WebsocketControllerSingleton
});

export const WebsocketProvider = ({ children }: any) => {
    // Contexts
    const { webSocketController } = useContext(WebsocketContext);

    // Logic
    return (
        <WebsocketContext.Provider value={{webSocketController}}>
            { children }
        </WebsocketContext.Provider>
    );
};